/**
 * Types partagés pour les comptes utilisateurs
 */

export type UserRole = 'admin' | 'moderator' | 'player';

export interface AuthUser {
  id: number;
  email: string;
  role: UserRole;
  driverId: number | null;
  carId: number | null;
  /** Compte bloqué (refus de connexion). */
  banned?: boolean;
}

/** Pilote rattaché à un compte (vue admin). */
export interface AdminUserDriver {
  id: number;
  firstName: string;
  lastName: string;
  division: number;
}

/** Compte enrichi pour la page admin Comptes. */
export interface AdminUserView extends AuthUser {
  banned: boolean;
  firstName: string | null;
  lastName: string | null;
  drivers: AdminUserDriver[];
}

export interface RegisterBody {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  nationality: string;
}

export interface LoginBody {
  email: string;
  password: string;
}

export interface AuthResponse {
  token: string;
  user: AuthUser;
}

export function canManageRoster(role: UserRole): boolean {
  return role === 'admin';
}

export function canProposeCircuit(role: UserRole): boolean {
  return role === 'admin' || role === 'moderator';
}

export function canPlayOtherDriver(role: UserRole): boolean {
  return role === 'admin' || role === 'moderator';
}

/** Un `player` ne peut claim (dans le lobby d'une manche) que son propre
 * pilote lié à son compte ; admin/modo peuvent claim n'importe lequel. */
export function canClaimDriver(
  role: UserRole,
  requestedDriverId: number,
  ownDriverId: number | null
): boolean {
  return canPlayOtherDriver(role) || requestedDriverId === ownDriverId;
}
